exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.line-margin {\n\tmargin-top:6px;\n}\n.sign-in-form__subtitle {\n\tmargin-bottom: 35px;\n}\n.password-assist {\n\tmargin-bottom: 40px;\n}\n.register-link {\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n}\n.register-link--label {\n\tmargin-right: 25px;\n}\n", ""]);

// exports
